import { render, staticRenderFns } from "./ConfirmDeleteInvoiceForm.vue?vue&type=template&id=1b9ab6f4&scoped=true&"
import script from "./ConfirmDeleteInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteInvoiceForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeleteInvoiceForm.vue?vue&type=style&index=0&id=1b9ab6f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ab6f4",
  null
  
)

export default component.exports